import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'トップ', path: '/' },
    { name: '会社概要', path: '/about' },
    { name: '事業内容', path: '/service' },
    { name: '採用情報', path: '/recruit' },
    { name: 'お問い合わせ', path: '/contact' }
  ];

  return (
    <>
      <header
        id="navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isHomePage && !isScrolled
            ? 'bg-transparent'
            : 'bg-white shadow-md'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link
              to="/"
              className="text-xl sm:text-2xl font-bold transition-colors duration-300 text-[#2C3E50]"
            >
              おかやま介護認定調査株式会社
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-medium transition-colors duration-300 hover:text-[#5D9B9B] whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-[#5D9B9B]'
                      : 'text-[#2C3E50]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer text-[#2C3E50]"
              aria-label="メニュー"
            >
              <span
                className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                  isMenuOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              ></span>
              <span
                className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                  isMenuOpen ? 'opacity-0' : ''
                }`}
              ></span>
              <span
                className={`w-6 h-0.5 bg-[#2C3E50] transition-all duration-300 ${
                  isMenuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              ></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          isMenuOpen ? 'visible' : 'invisible'
        }`}
      >
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            isMenuOpen ? 'opacity-50' : 'opacity-0'
          }`}
          onClick={() => setIsMenuOpen(false)}
        ></div>
        <div
          className={`absolute top-0 right-0 bottom-0 w-80 max-w-full bg-white shadow-2xl transition-transform duration-300 ${
            isMenuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <span className="text-lg font-bold text-[#2C3E50]">メニュー</span>
            <button
              onClick={() => setIsMenuOpen(false)}
              className="w-10 h-10 flex items-center justify-center text-[#2C3E50] cursor-pointer"
              aria-label="閉じる"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
          </div>
          <nav className="p-6">
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`block px-4 py-3 rounded-lg font-medium transition-colors duration-300 cursor-pointer ${
                      location.pathname === link.path
                        ? 'bg-[#5D9B9B] text-white'
                        : 'text-[#2C3E50] hover:bg-gray-100'
                    }`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8 pt-8 border-t border-gray-200">
              <a
                href="tel:086-012-3456"
                className="flex items-center gap-3 px-4 py-3 bg-[#2C3E50] text-white rounded-lg font-medium hover:bg-[#1a252f] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>086-012-3456</span>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}
